import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 12 12",
	stroke: "currentColor",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Icons/refresh-ccw",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M0.5 2V3.66667C0.5 4.40305 1.09695 5 1.83333 5H3.5",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M11.5 10V8.33333C11.5 7.59695 10.903 7 10.1667 7H8.5",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M10.245 4.50004C9.99142 3.78343 9.56043 3.14274 8.99227 2.63775C8.4241 2.13275 7.73727 1.77992 6.99586 1.61217C6.25445 1.44441 5.48262 1.46721 4.75241 1.67842C4.02219 1.88964 3.35737 2.28239 2.82 2.82004L1 4.66675M11 7.50004L9.18 9.18004C8.66667 9.66675 7.97781 10.1104 7.2476 10.3217C6.51738 10.5329 5.74555 10.5557 5.00414 10.3879C4.26273 10.2202 3.5759 9.86732 3.00773 9.36233C2.43957 8.85734 2.00858 8.21664 1.755 7.50004",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgRefresh;
